import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesFilterFiltersAppliedActive = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      d="M11.1 6.4 9 8.5V13H8V8.5L3.6 4H10V3H3.5c-1.1 0-1.2 1.2-.6 1.8L7 9v4c0 .5.5 1 1 1h1c.5 0 1-.5 1-1V9l1.8-1.9-.7-.7z"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#333",
      }}
    />
    <circle
      cx={14.5}
      cy={3.5}
      r={3.5}
      style={{
        fill: "#2fa37d",
      }}
    />
  </svg>
);
const Memo = memo(SvgSpacesFilterFiltersAppliedActive);
export default Memo;
